import React from 'react';

import { flagStyles } from '../settings';

const SvgGW = (): JSX.Element => (
  <img
    style={{
      backgroundPosition: '-2184px 0px',
      ...flagStyles
    }}
    alt=""
  />
);

export default SvgGW;
